import React from "react";
import { Menubar as PrimeMenubar } from "primereact/menubar";
import { Button } from "primereact/button";
import { FaFileCode } from "react-icons/fa6";
import { MenubarPropsType } from "../../types/menubar";
import "./menubar.css";

const Menubar: React.FC<MenubarPropsType> = ({
    model,
    onLogoClick,
    onLinkedInClick,
}) => {
    const start = (
        <Button
            type="button"
            onClick={onLogoClick}
            className="p-button-secondary"
        >
            <FaFileCode size={25} color="black" />
        </Button>
    );

    const end = (
        <Button
            label=""
            type="button"
            icon="pi pi-linkedin"
            className="p-button-outlined p-button-secondary"
            data-testid="LinkedIn"
            onClick={onLinkedInClick}
        />
    );

    return (
        <PrimeMenubar
            className="p-mb-6 custom-menubar"
            model={model}
            start={start}
            end={end}
        />
    );
};

export default Menubar;
